module.exports = __webpack_public_path__ + "img/bg-form-lower.22946166.png";